export default __webpack_public_path__ + "static/media/control-agro-img.0206fd2f.jpg";